function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.13209 2.87994C3.54984 2.60144 4.11427 2.71432 4.39277 3.13208L8.02914 8.58662C8.30764 9.00438 8.19475 9.5688 7.777 9.84731C7.35925 10.1258 6.79482 10.0129 6.51632 9.59517L2.87995 4.14062C2.60145 3.72287 2.71434 3.15844 3.13209 2.87994Z",
  fill: "#738AA5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.1406 7.42539C13.7229 7.14689 13.1585 7.25978 12.88 7.67753L9.24359 13.1321C8.96509 13.5498 9.07797 14.1143 9.49573 14.3928C9.91348 14.6713 10.4779 14.5584 10.7564 14.1406L14.3928 8.68608C14.6713 8.26832 14.5584 7.7039 14.1406 7.42539Z",
  fill: "#738AA5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.2727 3.63636C17.2727 3.13429 16.8657 2.72727 16.3636 2.72727H8.63636C8.13429 2.72727 7.72727 3.13429 7.72727 3.63636C7.72727 4.13844 8.13429 4.54545 8.63636 4.54545H16.3636C16.8657 4.54545 17.2727 4.13844 17.2727 3.63636Z",
  fill: "#738AA5"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20 3.63636C20 5.64467 18.3719 7.27273 16.3636 7.27273C14.3553 7.27273 12.7273 5.64467 12.7273 3.63636C12.7273 1.62806 14.3553 0 16.3636 0C18.3719 0 20 1.62806 20 3.63636Z",
  fill: "#738AA5"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M7.27273 3.63636C7.27273 5.64467 5.64467 7.27273 3.63636 7.27273C1.62806 7.27273 0 5.64467 0 3.63636C0 1.62806 1.62806 0 3.63636 0C5.64467 0 7.27273 1.62806 7.27273 3.63636Z",
  fill: "#738AA5"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6364 13.6364C13.6364 15.6447 12.0083 17.2727 10 17.2727C7.99169 17.2727 6.36364 15.6447 6.36364 13.6364C6.36364 11.6281 7.99169 10 10 10C12.0083 10 13.6364 11.6281 13.6364 13.6364Z",
  fill: "#738AA5"
});

function SvgSyndicatorsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyndicatorsIcon);
export default __webpack_public_path__ + "static/media/SyndicatorsIcon.2509949d.svg";
export { ForwardRef as ReactComponent };